import React from 'react';

import FieldWrapper from '../Field-wrapper';
import styles from '../Fields.module.less';

import { passwordStrength } from '$Utils';
/**
 *
 * @deprecated all new forms should use HVUI/FormikForm and HVUI/FormControl
 */
class Password extends React.Component {
    state = {
        zxcvbnLoaded: false,
        score: 0,
        visible: false,
        zxcvbnError: false
    };
    componentDidMount = () => {
        if (this.props.value) this.checkScore(this.props.value);
    };
    toggleVisibility = () => {
        this.setState({
            visible: !this.state.visible
        });
    };
    checkScore = async e => {
        if (!e || !e.target || !e.target.value || this.state.zxcvbnError)
            return;
        const value = e.target.value;
        const strength = await passwordStrength(value);
        if (strength == null) return this.setState({ zxcvbnError: true });
        this.setState({ score: strength, zxcvbnLoaded: true });
    };
    render() {
        const {
            descriptions,
            disabled,
            id,
            inputClassName,
            name,
            placeholder,
            required,
            value,
            onChange,
            onBlur,
            onFocus,
            showHide = { show: 'show', hide: 'hide' },
            zxcvbnErrorText = [
                "We can't check the strength of your password right now.",
                'Refresh the page to try again.'
            ]
        } = this.props;

        const {
            zxcvbnLoaded,
            zxcvbnError,
            score = 0,
            strongEnough,
            visible
        } = this.state;

        const meterLength = `${score === 0 ? 10 : score * 25}%`;
        const meterSuffix = score > 2 ? 'strong' : score > 1 ? 'okay' : 'weak';
        const meterClassName = `meterSpan-${meterSuffix}`;

        return (
            <div
                data-score={score}
                data-strong-enough={strongEnough}
                className={styles['pw-wrapper']}
                data-zxcvbn-loaded={zxcvbnLoaded}
            >
                <input
                    disabled={disabled || zxcvbnError}
                    id={id || name}
                    name={name}
                    onChange={e => {
                        if (onChange) onChange(e);
                        return this.checkScore(e);
                    }}
                    onBlur={onBlur}
                    onFocus={onFocus}
                    placeholder={placeholder}
                    required={required}
                    className={styles[inputClassName]}
                    type={visible ? 'text' : 'password'}
                    value={value || ''}
                />
                {zxcvbnError && (
                    <div
                        className={styles['error']}
                        style={{ position: 'relative' }}
                    >
                        {zxcvbnErrorText[0]}
                        <br />
                        {zxcvbnErrorText[1]}
                    </div>
                )}
                {!zxcvbnError && (
                    <>
                        <button
                            type="button"
                            className={styles['visibility-toggle']}
                            onClick={this.toggleVisibility}
                        >
                            {this.state.visible ? showHide.hide : showHide.show}
                        </button>
                        <div className={styles['meter-container']}>
                            <span className={styles['meterText']}>
                                {descriptions[score]}
                            </span>
                            <div className={styles['meter']}>
                                <span
                                    className={styles[meterClassName]}
                                    style={{ width: meterLength }}
                                ></span>
                            </div>
                        </div>
                    </>
                )}
            </div>
        );
    }
}

Password.defaultProps = {
    descriptions: ['Very weak', 'Weak', 'Okay', 'Strong', 'Very Strong']
};

export default FieldWrapper(Password, { reduxForm: true, isPWCreate: true });
export const PasswordField = FieldWrapper(Password, { isPWCreate: true });
